/**
 * @about See VAT rate types specification on confluence
 * https://carvago.atlassian.net/wiki/spaces/TEAS/pages/567378064/CR+VAT+-+Rate+type
 */
export type VatRateType = 'S' | 'Z' | 'E' | 'R' | 'MR' | 'SR' | 'P';
